import { cloneDeep } from "lodash";
import { shouldNotDisplayLevelTab } from "./should-not-display-level-tab";
import { DatapointFormatEnum, DatapointIdStandardEnum, DatapointsEntityType } from "api/ux/src";
import { InspectDataTab } from "components/modal/widget-inspect-data/types";
import { processDisplayedLevelParams } from "./process-displayed-level-params";
export const isPacingTimeseries = (params) => params.some((x) => x.measures?.some((y) => y.context?.objective)) &&
    params.every((x) => x.dimensions?.every((y) => y.standardDatapoint !== DatapointIdStandardEnum.PortfolioPacingAllocation));
const shouldReturnOnlyFullHistoryForGeneralCase = (entityType, isComparisonWidget, timePeriod, widgetParams) => (((entityType !== DatapointsEntityType.Portfolio && isComparisonWidget) || !isComparisonWidget)) &&
    ((!timePeriod && !widgetParams[0]?.measures?.some((measure) => measure.timeSeries && measure.periods !== 1)));
const shouldReturnOnlyFullHistoryForManagerEntity = (entityType, timePeriod, widgetParams, inspectDataTabRequest) => ((entityType === DatapointsEntityType.Manager) &&
    inspectDataTabRequest.Asset[0]?.measures?.every((fh) => inspectDataTabRequest.FullHistory[0]?.measures?.some((x) => x.standardDatapoint === fh.standardDatapoint ||
        x.customDatapoint === fh.customDatapoint))) &&
    ((!timePeriod && !widgetParams[0]?.measures?.some((measure) => measure.timeSeries && measure.periods !== 1)));
export const getInspectDataTabsRequestParams = ({ entityType, widgetParams, timePeriod, isComparisonWidget, periodOfAnalysis, datapointsAllowedDimensions, clickthroughDatapoints, startDate, endDate, forceUseOriginalRequest }) => {
    const inspectDataTabRequest = {
        ActualsAndProjections: [],
        Asset: [],
        Cashflows: [],
        CommitmentPacingOutputs: [],
        FullHistory: [],
        Fund: [],
        Portfolio: []
    };
    if (!datapointsAllowedDimensions || datapointsAllowedDimensions.length === 0) {
        return inspectDataTabRequest;
    }
    const isPacingTimeserie = isPacingTimeseries(widgetParams);
    const hasProjected = widgetParams?.[0]?.measures?.some((measure) => measure.projected === true || measure.context?.projectedOnly === true);
    Object
        .values(InspectDataTab)
        .filter((level) => !shouldNotDisplayLevelTab({
        dataGranularity: timePeriod,
        entityType,
        hasProjected,
        isComparisonWidget,
        isPacingTimeserie,
        level,
        periodOfAnalysis,
        widgetParams
    }))
        .forEach((displayedLevel) => {
        const widgetParamsNew = cloneDeep(widgetParams);
        widgetParamsNew.forEach((param) => {
            param.measures?.forEach((measure) => {
                if (measure.format === DatapointFormatEnum.Percent) {
                    delete measure.format;
                }
            });
        });
        if (displayedLevel === "Portfolio") {
            inspectDataTabRequest[displayedLevel] = widgetParamsNew;
            return;
        }
        if (forceUseOriginalRequest) {
            inspectDataTabRequest[displayedLevel] = widgetParamsNew;
            return;
        }
        const processed = processDisplayedLevelParams({
            clickthroughDatapoints,
            datapointsAllowedDimensions,
            displayedLevel,
            endDate,
            entityType,
            hasProjected,
            startDate,
            timePeriod,
            widgetParams: widgetParamsNew
        });
        if (processed) {
            inspectDataTabRequest[displayedLevel] = processed;
        }
    });
    if (shouldReturnOnlyFullHistoryForGeneralCase(entityType, isComparisonWidget, timePeriod, widgetParams)) {
        return {
            ActualsAndProjections: [],
            Asset: [],
            Cashflows: [],
            CommitmentPacingOutputs: [],
            FullHistory: inspectDataTabRequest.FullHistory,
            Fund: [],
            Portfolio: []
        };
    }
    if (shouldReturnOnlyFullHistoryForManagerEntity(entityType, timePeriod, widgetParams, inspectDataTabRequest)) {
        return {
            ActualsAndProjections: [],
            Asset: [],
            Cashflows: [],
            CommitmentPacingOutputs: [],
            FullHistory: inspectDataTabRequest.FullHistory,
            Fund: [],
            Portfolio: []
        };
    }
    return inspectDataTabRequest;
};
